import { FetchHomePageOptions, FETCH_HOME_PAGE_OPTIONS } from '../actions/NavConfigActions';
import { getFetchHomePageOptionsRequestStatus } from '../selectors/RequestStatusSelector';
import RequestStatusTypes from '../constants/RequestStatusTypes';
import NavConfigAPI from '../api/NavConfigAPI';
import requestEntity from './requestEntity';
import RequestEpicDescriptor from './RequestEpicDescriptor';
export default requestEntity(new RequestEpicDescriptor({
  apiFunction: NavConfigAPI.getHomePageOptions,
  initiatingActionType: FETCH_HOME_PAGE_OPTIONS,
  requestStatusSelector: getFetchHomePageOptionsRequestStatus,
  requestStatusTypeFilters: [RequestStatusTypes.UNINITIALIZED],
  requestActions: FetchHomePageOptions
}));